/**
 * Logger utility for development-only logging
 * In production, most logs are suppressed to prevent information leakage
 *
 * To enable verbose logging, set window.VERBOSE_LOGGING = true in the console
 */

const isDevelopment = process.env.NODE_ENV === 'development';

// Verbose logging disabled by default to reduce console noise
// Enable in browser console with: window.VERBOSE_LOGGING = true
const isVerbose = () => typeof window !== 'undefined' && window.VERBOSE_LOGGING === true;

const logger = {
    /**
     * Log general information (dev only, verbose)
     */
    log: (...args) => {
        if (isDevelopment && isVerbose()) {
            console.log(...args);
        }
    },

    /**
     * Log debug information (dev only, verbose)
     */
    debug: (...args) => {
        if (isDevelopment && isVerbose()) {
            console.debug('[DEBUG]', ...args);
        }
    },

    /**
     * Log warnings (dev only)
     */
    warn: (...args) => {
        if (isDevelopment) {
            console.warn(...args);
        }
    },

    /**
     * Log errors (always - errors should be visible)
     */
    error: (...args) => {
        console.error(...args);
    },

    /**
     * Log API-related info (dev only, verbose)
     */
    api: (...args) => {
        if (isDevelopment && isVerbose()) {
            console.log('[API]', ...args);
        }
    },

    /**
     * Log auth-related info (dev only)
     * Note: Be careful not to log actual tokens
     */
    auth: (...args) => {
        if (isDevelopment && isVerbose()) {
            console.log('[AUTH]', ...args);
        }
    },
};

export default logger;
